module.exports = __webpack_public_path__ + "media/images/home/price-c9d206fc77267ab53b1c4f2bdcb11641.png";